module.exports = __webpack_public_path__ + "img/student_draw.40ee5482.png";